import React from 'react';

const LikedMealSection = ({ type, meals, expandedSections, toggleSection, onLikeMeal, scrollToMeal }) => {
  if (meals.length === 0) return null;
  
  const isExpanded = expandedSections.includes(`liked-${type}`);

  return (
    <div key={type} className="mb-6">
      <button 
        onClick={() => toggleSection(`liked-${type}`)}
        className="w-full text-left text-xl font-bold mb-2 capitalize flex items-center justify-between hover:text-blue-600 transition-colors bg-white p-3 rounded-lg shadow-sm"
      >
        <div>
          {type}
          <span className="text-gray-500 text-sm ml-2">({meals.length})</span>
        </div>
        <svg
          className={`w-5 h-5 transform transition-transform ${isExpanded ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isExpanded && (
        <div className="space-y-2">
          {meals.map((meal) => (
            <div 
              key={meal.id} 
              className="bg-white p-3 rounded-lg shadow-sm hover:shadow-md transition-shadow cursor-pointer"
              onClick={() => scrollToMeal(meal.id)}
            >
              <div className="flex justify-between items-start">
                <h4 className="text-sm font-medium">{meal.name}</h4>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onLikeMeal(meal);
                  }}
                  className="text-red-500 hover:text-red-600"
                >
                  Remove
                </button>
              </div>
              <div className="text-xs text-gray-500 mt-1">
                {meal.calories} cal · {meal.sodium} mg · {meal.carbs} g
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const LikedMealsPanel = ({ 
  likedMeals, 
  handleLikeMeal, 
  expandedSections, 
  toggleSection, 
  scrollToMeal, 
  onClearLiked,
  onSubmitMeals 
}) => {
  // Group meals by type
  const breakfastMeals = likedMeals.filter(meal => meal.type === 'breakfast');
  const lunchMeals = likedMeals.filter(meal => meal.type === 'lunch');
  const dinnerMeals = likedMeals.filter(meal => meal.type === 'dinner');

  return (
    <div className="bg-white p-6 rounded-lg shadow-sm h-fit sticky top-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Liked Meals</h2>
        <button
          onClick={onClearLiked}
          className="text-sm text-red-600 hover:text-red-700 transition-colors"
        >
          Empty List
        </button>
      </div>
      <div className="max-h-[calc(100vh-200px)] overflow-y-auto">
        {likedMeals.length === 0 ? (
          <p className="text-gray-500 text-center py-4">
            No meals liked yet. Click "I would like this" on any meal to add it here.
          </p>
        ) : (
          <div className="space-y-4">
            <LikedMealSection 
              type="breakfast"
              meals={breakfastMeals}
              expandedSections={expandedSections}
              toggleSection={toggleSection}
              onLikeMeal={handleLikeMeal}
              scrollToMeal={scrollToMeal}
            />
            <LikedMealSection 
              type="lunch"
              meals={lunchMeals}
              expandedSections={expandedSections}
              toggleSection={toggleSection}
              onLikeMeal={handleLikeMeal}
              scrollToMeal={scrollToMeal}
            />
            <LikedMealSection 
              type="dinner"
              meals={dinnerMeals}
              expandedSections={expandedSections}
              toggleSection={toggleSection}
              onLikeMeal={handleLikeMeal}
              scrollToMeal={scrollToMeal}
            />
          </div>
        )}
      </div>
      <button
        className="w-full bg-blue-600 text-white rounded-md py-2 px-4 hover:bg-blue-700 transition-colors mt-4"
        onClick={onSubmitMeals}
      >
        Submit
      </button>
    </div>
  );
};

export default LikedMealsPanel; 